<template>
  <div class="page">
    <div class="header-section">
      <div class="head-context">
        <div>
          <p class="weight">Guohuan Zhang</p>
          <p>
            <span class="weight">Titile/Position:</span> PhD candidate
          </p>
        </div>
        <div>
          <div class="weight">Affiliation:</div>
          <div>
            Institute of Reproductive and Child Health, School of Public
            Health,<br />
            Peking University, Beijing 100191, P.R. China
          </div>
        </div>
        <div>
          <span class="weight">Websiute: </span>
          <a href="https://github.com/Thuoyuing/Thuoyuing.github.io" target="_blank" class="blue">https://github.com/Thuoyuing/Thuoyuing.github.io</a>
        </div>
        <div>
          <span class="weight">Email: </span>
          <span class="blue">granhamzhang@foxmail.com </span>
        </div>
      </div>
      <div class="img">
        <img class="head" :src="img" alt="" />
      </div>
    </div>
    <div class="section">
      <div class="weight">Brief introduction:</div>
      <div class="content">
        I received my Bachelor’s degree (Preventive Medicine) and Master’s degree (Epidemiology and Biostatistics) in school of public health from Peking university (2015-2022). My main interest is the transport and delivery of environmental exposure in human body, especially between maternal blood and oocyte or fetus. To indicate the exposure level in a particular organ or tissue by low-invasive testing and statistical method is one of my research aims. I evaluated the concentration of trace element in follicular fluid by maternal blood and machine learning models in my master's graduation project. And my research about the enrichment of boron in follicular fluid has been published in Environmental Pollution. Now I'm working on my PhD in Research Center for Eco-Environmental Science, Chinese Academy of Sciences, Beijing.
      </div>
    </div>
    <div class="section">
      <div class="weight">Representative papers:</div>
      <p>
        1. <span class="weight">Zhang G</span>, Wang A, Zhuang L, et al. Enrichment of boron element in follicular fluid and its potential effect on the immune function[J]. Environmental Pollution, 2022, 304: 119147.
      </p>
      <p>
        2. Li M, Zhuang L, <span class="weight">Zhang G</span>, et al. Association between exposure of light rare earth elements and outcomes of in vitro fertilization-embryo transfer in North China[J]. Science of The Total Environment, 2021, 762: 143106. (DOI: 10.1016/j.scitotenv.2020.143106.)
      </p>
      <p>
        3. Wang B, Fu J, Gao K, Liu Q, Zhuang L, <span class="weight">Zhang G</span>, et al. Early pregnancy loss: Do Per- and polyfluoroalkyl substances matter? [J]. Environment International, 2021, 157: 106837. (DOI: 10.1016/j.envint.2021.106837.)
      </p>
      <p>
        4. Wang L, Liang R, <span class="weight">Zhang G</span>, et al. Serum zinc concentration and risk of adverse outcomes to in vitro fertilization and embryo transfer: A prospective cohort study in northern China[J]. Science of The Total Environment, 2021, 792: 148405. (DOI: 10.1016/j.scitotenv.2021.148405.)
      </p>
    </div>
  </div>
</template>
<script>
import img from '@/assets/people/zgh.jpg';
export default {
  data() {
    return {
      img
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  padding: 20px 30px;
  text-align: left;
  font-size: $webpage-base-font-size;
}
.header-section {
  display: flex;
}
.head-context {
  display: flex;
  flex-direction: column;
  gap: 18px
}
.head {
  height: 200px;
  margin-left: 160px;
}
p {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  margin-bottom: 0;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
}
.weight {
  font-weight: 600
}
.section {
  margin-top: 20px;
  padding-right: 25px;
}
.blue {
  color: $blue-light-1
}
.img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .header-section {
    display: flex;
    flex-direction: column;
  }
  .head {
    margin-left: 0;
    margin-top: 18px
  }
}
</style>

